import React from 'react';

interface CloseIconProps {
  width?: string;
  height?: string;
}
const CloseIcon = ({ width = '20px', height = '20px' }: CloseIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 20 20"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Close icon</title>
    <path
      clipRule="evenodd"
      d="M19.3334 2.53341L17.4667 0.666748L10.0001 8.13341L2.53341 0.666748L0.666748 2.53341L8.13341 10.0001L0.666748 17.4667L2.53341 19.3334L10.0001 11.8667L17.4667 19.3334L19.3334 17.4667L11.8667 10.0001L19.3334 2.53341Z"
      fill="white"
      fillRule="evenodd"
      id="closeicon"
    />
  </svg>
);

CloseIcon.defaultProps = {
  width: '20px',
  height: '20px',
};

export default CloseIcon;
